import { render, staticRenderFns } from "./HotelTwo.vue?vue&type=template&id=4d254054&"
import script from "./HotelTwo.vue?vue&type=script&lang=js&"
export * from "./HotelTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports